import {LinearProgress} from "@mui/material";
import React, {useLayoutEffect, useMemo, useState} from "react";
import {useApiPromises} from "@contexts/hooks/api/useApiPromises.ts";
import {hasPromisePending, promiseState} from "@models/helpers.ts";

export const LoadingAnythingProgressBar: React.FC = () => {
    const apiPromises = useApiPromises();


    const [isLoadingSomething, setIsLoadingSomething] = useState<boolean>(false);

    const promises = useMemo(() => {
        return apiPromises?.map(p => {
            promiseState(p).then(x => x === 'pending' ? p : null).finally(() => {
                return null;
            })

        }).filter(p => p !== null) || [];
    }, [apiPromises]);


    useLayoutEffect(() => {
        if (apiPromises && apiPromises.length > 0) {
            if (hasPromisePending(apiPromises))
                setIsLoadingSomething(true);
            Promise.all(apiPromises).then(() => {
                setIsLoadingSomething(false);
            }).catch(() => {
                setIsLoadingSomething(false);
            });
        }
        return () => {
            setIsLoadingSomething(false);
        };
    }, [promises]);


    return (
        <LinearProgress value={isLoadingSomething ? undefined : -100}
                        color={"info"}
                        variant={isLoadingSomething ? 'query' : 'determinate'}/>
    )
}